import React from 'react';
import { ChevronLeft } from 'lucide-react';

const OrderHeader = ({
    scriptName,
    exchange,
    price,
    lotsSize,
    netChange,
    percentChange,
    buttonType,
    onGoBack
}) => {
    const isPositive = (netChange ?? 0) >= 0;
    const priceColor = buttonType === "buy" ? "#089981" : "#f23645";

    return (
        <div className="bg-gray-100 p-3">
            <div className="flex items-center justify-between">
                {/* Left Side Content */}
                <div className="flex items-center space-x-2">
                    <span className="font-black cursor-pointer">
                        <ChevronLeft size={16} onClick={onGoBack} />
                    </span>
                    <span className="font-lato font-semibold text-black text-[14px]">
                        {scriptName}
                    </span>
                </div>
            </div>
            <div className="flex items-center justify-between mt-2">

                <span className="font-lato text-black text-[12px] font-medium uppercase py-1 px-2 rounded-sm">
                    {exchange}
                </span>

                {/* Right Side Content */}
                <span
                    className="font-lato font-semibold text-[18px] ml-auto"
                    style={{ color: priceColor }}
                >
                    {price}
                </span>
            </div>
            <div className="flex justify-between items-center">
                {/* Left Side Content */}
                <div className="flex items-center">
                    <span className="text-gray-500 text-[12px] p-2 ml-4">
                        Lots size : {lotsSize}
                    </span>
                </div>

                {/* Right Side Content */}
                <span className="text-gray-500 text-[12px]">
                    {isPositive ? `+${netChange}` : netChange}
                    {` (${percentChange}%)`}
                </span>
            </div>
        </div>
    );
};

export default OrderHeader;